import survey1 from './survey-1.json';
import survey2 from './survey-2.json';
import survey3 from './survey-3.json';
import survey4 from './survey-4.json';
import survey5 from './survey-5.json';

const surveyConfigs: Record<string, object> = {
    'survey-1': survey1,
    'survey-2': survey2,
    'survey-3': survey3,
    'survey-4': survey4,
    'survey-5': survey5,
};

export default surveyConfigs;
